module.exports = __webpack_public_path__ + "images/mic9a1ce34e0e7b1fc77c66750c9a550d39.svg";